import React, { useState, useRef, useEffect } from 'react';
import './registerflow.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import registerEmployer from '../../../assets/images/Ic_employer.png';
import registerCandidate from '../../../assets/images/candidate.png';
import Success from '../../../assets/images/im_Success.png';
import CloseIcon from '../../../assets/images/Ic_close.png';
import { ClientPreLoginService } from '../../../services/clientPreLoginService';
import { MasterDataService } from '../../../services/masterDataService';
const RegisterFlow = ({ visible, onClose }) => {

  const [formData, setFormData] = useState({
    name: '',
    designation: '',
    industry: '',
    industrySubcategory: '',
    mobile: '',
    companyName: '',
    emailId: '',
    companyAddrPinCode: '',
  });
  const [industryList, setIndustryList] = useState([]);
  const [subcategoryList, setSubcategoryList] = useState([]);

  const [showEmployerForm, setShowEmployerForm] = useState(false);
  const [showOTPPopup, setShowOTPPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showDuplicateAlert, setShowDuplicateAlert] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const otpInputs = useRef([]);

  useEffect(() => {
    MasterDataService.getAllIndustrySectors()
      .then(res => {
        setIndustryList(res.data || []);
      })
      .catch(() => setIndustryList([]));
  }, []);


  useEffect(() => {
    const selectedIndustry = formData.industry;

    if (!selectedIndustry) {
      setSubcategoryList([]);
      return;
    }

    const industryObj = industryList.find(
      (i) => i.industrySector === selectedIndustry
    );

    if (!industryObj) return;

    MasterDataService.getIndustrySubcategories(industryObj.id)
      .then(res => setSubcategoryList(res.data || []))
      .catch(() => setSubcategoryList([]));
  }, [formData.industry, industryList]);

  if (!visible) return null;
  const handleEmployerClick = () => {
    setShowEmployerForm(true);
  };
  const handleCandidateClick = () => {
    window.location.href = '/candidate/registration'
  }
  // const handleBackClick = () => {
  //   setShowEmployerForm(false);
  // };


  const handleBackClick = () => {
    setFormData({
      name: '',
      designation: '',
      industry: '',
      mobile: '',
      companyName: '',
      emailId: '',
      companyAddrPinCode: '',
    });
    setFormErrors('');

    setShowEmployerForm(false);
  };


  const handleClosePopup = () => {
    setFormData({
      name: '',
      designation: '',
      industry: '',
      mobile: '',
      companyName: '',
      emailId: '',
      companyAddrPinCode: '',
    });
    setFormErrors('');
    setShowEmployerForm(false);
    setShowOTPPopup(false);
    setShowSuccessPopup(false);
    setShowDuplicateAlert(false);
    onClose();
  };


  // const handleRegisterClick = (e) => {
  //   e.preventDefault();
  //   setShowOTPPopup(true);
  // };
  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: type === 'checkbox' ? checked : value
  //   }));
  // };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "industry" ? { industrySubcategory: "" } : {})
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: validateField(name, value)
    }));
  };

  const validateField = (name, value) => {
    switch (name) {
      case 'name':
        if (!value.trim()) return 'Name is required';
        if (!/^[a-zA-Z\s]+$/.test(value)) return 'Only letters and spaces allowed';
        break;

      case 'designation':
        if (!value.trim()) return 'Designation is required';
        if (!/^[a-zA-Z0-9\s\-–&.]+$/.test(value)) return 'Use only letters, numbers, spaces, -, &, and .';
        break;

      case 'industry':
        if (!value.trim()) return 'Industry is required';
        break;

      case 'companyName':
        if (!value.trim()) return 'Company name is required';
        if (value.length < 2) return 'Too short';
        break;

      case 'mobile':
        if (!value.trim()) return 'Mobile is required';
        if (!/^\+91[6-9]\d{9}$/.test(value)) return 'Mobile number must include +91 and be valid';
        break;


      case 'emailId':
        if (!value.trim()) return 'Email is required';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Invalid email';
        break;

      case 'companyAddrPinCode':
        if (!value.trim()) return 'Pincode is required';
        if (!/^\d{6}$/.test(value)) return 'Pincode must be 6 digits';
        break;

      default:
        break;
    }

    return '';
  };


  const handleRegisterClick = async (e) => {
    e.preventDefault();

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) newErrors[key] = error;
    });

    setFormErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    if (!formData.mobile.startsWith("+91")) {
      setFormErrors((prev) => ({
        ...prev,
        mobile: "Mobile number must start with +91",
      }));
      return;
    }

    const payload = {
      companyName: formData.companyName,
      industry: formData.industry,
      industrySubcategory: formData.industrySubcategory,
      contactPerson: {
        username: null,
        name: formData.name,
        designation: formData.designation,
        phoneNumber: formData.mobile,
        emailId: formData.emailId,
        clientRole: 'PRIMARY',
        dpPath: null,
        dpFileContent: null,
        docs: null
      },
      companyAddrPinCode: formData.companyAddrPinCode
    };

    try {
      const res = await ClientPreLoginService.ClientRegistration(payload);
      setShowSuccessPopup(true);
    } catch (error) {
      console.error("Registration failed", error);

      const errorMessage = error?.response?.data?.message || error?.response?.data;

      if (typeof errorMessage === 'string' && errorMessage.includes('Duplicate entry')) {
        setShowDuplicateAlert(true);
      } else if (typeof errorMessage === 'string' && errorMessage.toLowerCase().includes('invalid')) {
        setFormErrors(prev => ({
          ...prev,
          companyAddrPinCode: errorMessage
        }));
      } else {
        alert("Something went wrong. Please try again later.");
      }
    }

  };

  const handleOTPBackClick = () => {
    setShowOTPPopup(false);
  };

  const handleVerifyClick = () => {
    setShowSuccessPopup(true);
  };

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (value.length === 1 && index < otpInputs.current.length - 1) {
      otpInputs.current[index + 1].focus();
    }
  };
  const handleTerms = (path, section) => {
    if (!sessionStorage.getItem("initialScrollPosition")) {
      sessionStorage.setItem("initialScrollPosition", window.scrollY);
    }
    sessionStorage.setItem("scrollPosition", window.scrollY);
    window.location.href = `${path}?section=${section}`;
  };
  return (
    <div className="register-popup-overlay">
      {showSuccessPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="register-popup-close" onClick={onClose}>
              <img src={CloseIcon} alt="Close" />
            </button>
            <img src={Success} alt="success logo" className="success-logo" />
            <h3>Registration successful!</h3>
            <span>You will receive your login credentials in the registered EmailID</span>
          </div>
        </div>
      )}
      {showDuplicateAlert && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="register-popup-close" onClick={() => setShowDuplicateAlert(false)}>
              <img src={CloseIcon} alt="Close" />
            </button>
            <h3>You're already registered!</h3>
            <p>Please log in to continue.</p>
            <button
              className="login-button"
              onClick={() => window.location.href = "/login"}
              style={{
                backgroundColor: "#F35824",
                color: "#fff",
                padding: "10px 20px",
                border: "none",
                borderRadius: "100px",
                cursor: "pointer",
                marginTop: "10px"
              }}
            >
              Go to Login
            </button>
          </div>
        </div>
      )}

      {!showEmployerForm ? (
        <div className="register-popup-container">
          <button className="back-button" onClick={handleClosePopup}>
            <img src={CloseIcon} alt="Close" />
          </button>

          <h2 className="register-head">I am….</h2>
          <div className="register-popup-buttons">
            <button className="register-popup-button employer" onClick={handleEmployerClick}>
              <div className="register-icon-container">
                <div className="register-icon-background">
                  <img src={registerEmployer} alt="Employer" className="register-icon-image" />
                </div>
              </div>
              <p>Employer</p>
            </button>
            <button className="register-popup-button candidate" onClick={handleCandidateClick}>
              <div className="register-icon-container">
                <div className="register-icon-background">
                  <img src={registerCandidate} alt="Candidate" className="register-icon-image" />
                </div>
              </div>
              <p>Candidate</p>
            </button>
          </div>
        </div>
      ) : showOTPPopup ? (
        <div className={`otp-popup-container ${showSuccessPopup ? 'hidden' : ''}`}>
          <button className="back-button" onClick={handleOTPBackClick}>
            <img src={CloseIcon} alt="Close" />
          </button>
          <h2 className="otp-form-head">Confirm Your Registration</h2>
          <p className="otp-instruction">Verify Your Mobile Number</p>
          <p className="otp-mobile">
            Enter The 4-Digit OTP Sent to{' '}
            <span className="registered-mobile-number">
              {' '}
              +91 9XXXX XX231 <FontAwesomeIcon icon={faPen} className="edit-icon" />
            </span>
          </p>
          <div className="otp-input-container">
            {[...Array(4)].map((_, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                className="otp-input"
                ref={(el) => (otpInputs.current[index] = el)}
                onChange={(e) => handleInputChange(e, index)}
              />
            ))}
          </div>
          <button className="verify-button" onClick={handleVerifyClick}>
            Verify
          </button>
        </div>
      ) : (
        <div className="register-formpopup-container">
          <button className="back-button" onClick={handleBackClick}>
            <img src={CloseIcon} alt="Close" className="register-close-icon" />
          </button>
          <h2 className="employer-form-head">You Are a Step Away From Finding The Right Candidate</h2>
          <form className="register-form">
            <div className="register-form-row">
              <div className="col-md-6 custom-form-group">
                <label>
                  Name*
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className={`register-input ${formErrors.name ? 'input-error' : ''}`} spellCheck='false' />
                  {formErrors.name && <p className="error-text">{formErrors.name}</p>}

                </label>
              </div>
              <div className="col-md-6 custom-form-group">
                <label>
                  Designation*
                  <input type="text" name="designation" value={formData.designation} onChange={handleChange} className={`register-input ${formErrors.designation ? 'input-error' : ''}`} spellCheck='false' />
                  {formErrors.designation && <p className="error-text">{formErrors.designation}</p>}

                </label>
              </div>
            </div>
            <div className="register-form-row">
              <div className="col-md-6 custom-form-group">
                <label>
                  Industry*
                  <select
                    name="industry"
                    value={formData.industry}
                    onChange={handleChange}
                    className="register-input"
                  >
                    <option value="">-- Select Industry --</option>
                    {industryList.map((item) => (
                      <option key={item.id} value={item.industrySector}>
                        {item.industrySector}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <div className="col-md-6 custom-form-group">
                <label>
                  Industry Subcategory
                  <select
                    name="industrySubcategory"
                    value={formData.industrySubcategory}
                    onChange={handleChange}
                    className="register-input"
                    disabled={!subcategoryList.length}
                  >
                    <option value="">
                      {subcategoryList.length
                        ? "-- Select Subcategory --"
                        : "Select Industry first"}
                    </option>

                    {subcategoryList.map((sub) => (
                      <option key={sub.id} value={sub.subcategory}>
                        {sub.subcategory}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
            <div className="register-form-row">

              <div className="col-md-6 custom-form-group">
                <label>
                  Company Name*
                  <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} className={`register-input ${formErrors.companyName ? 'input-error' : ''}`} spellCheck='false' />
                  {formErrors.companyName && <p className="error-text">{formErrors.companyName}</p>}

                </label>
              </div>

              <div className="col-md-6 custom-form-group">
                <label>
                  Mobile Number*
                  <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} className={`register-input ${formErrors.mobile ? 'input-error' : ''}`} spellCheck='false' />
                  {formErrors.mobile && <p className="error-text">{formErrors.mobile}</p>}

                  {/* <p className="form-helper-text">OTP will be sent to your mobile number</p> */}
                </label>
              </div>
            </div>
            <div className="register-form-row">
              <div className="col-md-6 custom-form-group">
                <label>
                  Email Address*
                  <input type="email" name="emailId" value={formData.emailId} onChange={handleChange} className={`register-input ${formErrors.emailId ? 'input-error' : ''}`} spellCheck='false' />
                  {formErrors.emailId && <p className="error-text">{formErrors.emailId}</p>}

                  <p className="form-helper-text">This will be your login ID</p>
                </label>
              </div>


              <div className="col-md-6 custom-form-group">
                <label>
                  Pincode*
                  <input type="text" name="companyAddrPinCode" value={formData.companyAddrPinCode} onChange={handleChange} className={`register-input ${formErrors.companyAddrPinCode ? 'input-error' : ''}`} spellCheck='false' />
                  {formErrors.companyAddrPinCode && <p className="error-text">{formErrors.companyAddrPinCode}</p>}

                </label>
              </div>
            </div>

          </form>
          <p className="terms-conditions">
            By continuing you accept all our <a className='terms-and-conditions' onClick={() => handleTerms("/policy", "terms")}>Terms & Conditions</a>
          </p>
          <div className="register-button-container">
            <button type="submit" className="register-button"
              onClick={handleRegisterClick}
            >
              Register
            </button>
          </div>
          <p className="user-log">
            Already a user?{' '}
            <a href="/login" style={{ color: '#F35824', textDecoration: 'none', marginLeft: '5px', fontWeight: '600' }}>
              Log In
            </a>
          </p>
        </div>
      )}
    </div>
  );
};

export default RegisterFlow;
